/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {prepareUserOp} from '../api'

export const useMutationPrepareUserOp = createReactQueryMutationHook('prepareUserOp', prepareUserOp)
